export const FIGMA_BASE_WIDTH = 393;
export const FIGMA_BASE_HEIGHT = 852;

